class FooterBranded {
  init() {
    this.view = new Vue({
      el: "#vue-footer",
      name: "footer-branded",
      data() {
        return {
          basketClient: AnyBasket.inst,
          get currency() {
            return this.basketClient.currency;
          },
        }
      },
    })
  }
}

const footerBranded = new FooterBranded()
footerBranded.init()
